// extracted by mini-css-extract-plugin
export var list = "listTemplate-module--list--D9xrQ";
export var jsAnimInit = "listTemplate-module--jsAnimInit--1xuEl";